import React, { useEffect, useState } from "react";

/**
 * V17 acid blob backdrop.
 * - Default: mouse-tracked.
 * - `auto` mode: blobs drift slowly via CSS keyframes (no mouse).
 */
const Backdrop = ({ auto = false }) => {
  const [pos, setPos] = useState({ x: 50, y: 50 });
  useEffect(() => {
    if (auto) return;
    const onMove = (e) => {
      setPos({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [auto]);

  if (auto) {
    return (
      <div className="ggl-backdrop" aria-hidden>
        <div
          className="ggl-blob ggl-drift-lime"
          style={{
            width: "46vw",
            height: "46vw",
            background:
              "radial-gradient(ellipse at 40% 40%, #c8ff2a 0%, #6dff8a 45%, transparent 75%)",
          }}
        />
        <div
          className="ggl-blob ggl-drift-pink"
          style={{
            width: "42vw",
            height: "42vw",
            background:
              "radial-gradient(ellipse at 60% 60%, #ff2a8f 0%, #ff7eb8 35%, transparent 70%)",
          }}
        />
        <div
          className="ggl-blob ggl-drift-cyan"
          style={{
            width: "26vw",
            height: "26vw",
            background:
              "radial-gradient(ellipse at 50% 50%, #2ad6ff 0%, transparent 70%)",
          }}
        />
        <div
          className="ggl-scan"
          style={{
            backgroundImage:
              "repeating-linear-gradient(38deg, transparent 0 12px, #c8ff2a 12px 13px)",
          }}
        />
        <div className="ggl-grain" />
      </div>
    );
  }

  return (
    <div className="ggl-backdrop" aria-hidden>
      {/* Lime blob */}
      <div
        className="ggl-blob"
        style={{
          left: `${pos.x - 32}%`,
          top: `${pos.y - 28}%`,
          width: "46vw",
          height: "46vw",
          background:
            "radial-gradient(ellipse at 40% 40%, #c8ff2a 0%, #6dff8a 45%, transparent 75%)",
        }}
      />
      {/* Hot pink blob */}
      <div
        className="ggl-blob"
        style={{
          right: `${pos.x - 65}%`,
          bottom: `${pos.y - 55}%`,
          width: "42vw",
          height: "42vw",
          background:
            "radial-gradient(ellipse at 60% 60%, #ff2a8f 0%, #ff7eb8 35%, transparent 70%)",
        }}
      />
      {/* Cyan accent */}
      <div
        className="ggl-blob"
        style={{
          left: `${pos.x - 50}%`,
          bottom: `${pos.y - 35}%`,
          width: "26vw",
          height: "26vw",
          background:
            "radial-gradient(ellipse at 50% 50%, #2ad6ff 0%, transparent 70%)",
        }}
      />
      {/* Diagonal scan */}
      <div
        className="ggl-scan"
        style={{
          backgroundImage:
            "repeating-linear-gradient(38deg, transparent 0 12px, #c8ff2a 12px 13px)",
        }}
      />
      {/* Grain */}
      <div className="ggl-grain" />
    </div>
  );
};

export default Backdrop;
